<template>
  <section class="link-box">
   <p class="title">その他の状況を占う</p>
    <div class="block-other-appraisal">
      <!-- <a :href="linkUrl" v-html="linkName"></a> -->
      <a 
      v-for="(item , idx) in linkListMod"
      :key="idx"
      :href="linkUrl" v-html="linkName"></a> 
      <a href="/products/45/0001/result">あなたの本質について</a>
    </div>
  </section>
</template>

<script>
  const targetUrlList = {
    page0001:{
      url:'/products/45/0001/result',
      title:'aaa1'
    },
    page0002:{
      url:'/products/45/0001/result',
      title:'aaa2'
    },
    page0003:{
      url:'/products/45/0001/result',
      title:'aaa3'
    },
  }
  const kumiawase = {
    page0001:[
      'page0002','page0003'
    ],
    page0002:[
      'page0001','page0003'
    ],
    page0003:[
      'page0002','page0001'
    ]
  }

export default {
  name: 'SimpleLinkMenuBlock',
  props:{
    linkList:{
      type: Array,
      required: true
    },
    page: {
      type: String,
      default: '',
    },
  },
  computed:{
    linkListMod(){
      return kumiawase[`page${this.pageId}`].map(item=>{
        return targetUrlList[item]
      })
    }
  },
  data(){
    return{
      linkName:'これから待ち受ける占ってみませんか？2',
      linkUrl:'/products/45/0001/result'
    }
  },
  created() {
    if (this.linkName == 'products/45/0002/result') {
      this.linkName = 'これから待ち受ける占ってみませんか？'
      this.linkUrl = '/products/45/0002/result'
    }
    
  },
  mounted(){
    console.log(this.page)
  },
  methods: {
  
  },
}
</script>

<style scoped lang="scss">
$title-fontfamily:'Hiragino Mincho Pro';
$main-green:#00462E;
$uranai-black: #32373F;
$houen-blue:#3A89C9;
.link-box{
  padding-top:40px;
  padding-bottom: 60px;
  background-size: contain;
  background-image: url(/static/img/recommend/lp/houen/products/bk_result.png);
  background-repeat-y: repeat;
  }
.block-foot-message{
  display: flex;
  padding-top: 40px;
  img{
    width:128px;
    height: 142px;
    margin-right:16px;
    margin-bottom: 16px;
  }
  p{
    //font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-right: 20px;
  }
}
.block-other-appraisal{
  margin: 0 20px;
  border: 1px solid $uranai-black;
  a{
    padding: 20px;
    position: relative;
    text-decoration: none;
    display: block;
    border-bottom:1px solid  #dadada;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    background: #fff;
    &:after{
      content:'';
      border-top:2px solid $houen-blue;
      border-right:2px solid $houen-blue;
      position: absolute;
      width: 10px;
      height: 10px;
      right: 30px;
      top: 43%;
      transform: rotate(45deg);
    }
  }
}
.title{
  //font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color:$main-green;
  text-align: center;
  margin: 0;
  margin-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/SimpleLinkMenuBlock.vue